<template>
  <div class="api">
    <v-card-text>
      <v-row v-if='api == 1'>
        <v-col cols="3" >
          <v-text-field v-model="api_key" label="API KEY" dense readonly />
        </v-col>
        <v-col>
          <v-btn color="red" style="color: white" @click="GenApiKey">Сгенерировать новый</v-btn>
        </v-col>
      </v-row>
      <v-row v-else>
        <h2 style="width: 100%; text-align: center;padding: 30px">У вас тариф без API</h2>
      </v-row>
    </v-card-text>
    <v-card-text v-if='api == 1'>
      <v-row>
        <v-col cols="12">
          <h3>API Калькулятора Банковской гарантии</h3>
          <p style="background-color: #f44336; color: white; font-size: 1.2em; padding: 10px" >
            ВНИМАНИЕ Все запросы нужно отправлять с headers "Api-Token" и ваш
            токен <br />Ваш токен указан в поле выше
          </p>
          <p>
            Для отправки данных в калькулятор чтобы получить корректные данные
            сперва вам нужно получить списки:
            <ul>
              <li>вид закупок,</li>
              <li>вид гарантии,</li>
              <li>гарантия в пользу заказчика,</li>
              <li>ситуации у клиента</li>
              <li >сесию для сохранения расчета <span style="background-color: #f44336; color: white;padding: 5px" >(ВНИМАНИЕ при не получении новой сесии предыдущий расчет будет затерт новым)</span></li>
            </ul>
          </p>

          <p>
            сделать это можно по ссылке: https://t.finexpert.pro/api/DataToCalc
            (любой адрес) методом GET
          </p>
          <p>В ответ вы получите Объект с:</p>
          <pre v-html='getres'></pre>
          <p>
            Объект запроса для того чтобы сделать расчет https://t.finexpert.pro/api/calculate метод POST
          </p>
          <pre v-html='calculate'></pre>
          <p>В ответ вы получите Объект</p>
          <pre v-html='response'></pre>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>
<script>
export default {
  name: "api",
  components: {},
  data: () => ({
    response: `{
    calcdata:[{
	  acra: "AA-(RU)" <u><i>тип String</i></u>
      bail_note: Поручительство или депозит <u><i>тип String</i></u>
      bank: Наименование Банка <u><i>тип String</i></u>
      bank_id: id Банка <u><i>тип Number(integer)</i></u>
      ikom: стандартная комиссия  <u><i>тип String</i></u>
      ikomClient: комиссия клиента <u><i>тип String</i></u>
      ikomsk: коммисия за выдачу <u><i>тип String</i></u>
      paper: Метод доставки документов <u><i>тип String</i></u>
      paper_note: Описание какие документы нужны если используется бумажный вариант <u><i>тип String</i></u>
      product: Наименование продукта в системе <u><i>тип String</i></u>
      product_id: id продукта в нашей системе <u><i>тип Number(integer)</i></u>
      raexpert: "ruAA"  <u><i>тип String</i></u>
      rate: Рейтинг банка в нашей системе <u><i>тип Number(integer)</i></u> 0-5
      request_note:  Банковские правила  <u><i>тип String</i></u>
      short_info:
        principial = обязанности Принципала <u><i>тип String</i></u>
        life = Срок деятельности <u><i>тип String</i></u>
        principial_note = информация  <u><i>тип String</i></u>
      situation: Ситуации клиента  <u><i>тип String</i></u>
      tarif_note:  Описание тарифа <u><i>тип String</i></u>
      uslrab:
        rab = Условия работы с агентами  <u><i>тип String</i></u>
        snig= Снижение <u><i>тип String</i></u>
        prev= Привышение <u><i>тип String</i></u>
      vidObesp: Обеспечение  <u><i>тип String</i></u>
      website: Ссылка <u><i>тип String</i></u>
    }, и т.д.]
    newcount:{
      count: Количество расчетов которое осталось <u><i>тип Number(integer)</i></u>
      to_date: Дата в формате "YYYY-MM-DD" окончания действия тарифа  <u><i>тип String</i></u>
    }
  }`,
    calculate: `{
  action: "calculate" <u><i>тип String</i></u> значение “calculate”
  date_to: "2022-01-31" Срок гарантии с дата в формате <u><i>тип String</i></u> вид 'YYYY-MM-DD'
  date_from: "2021-04-26" Срок гарантии по дата в формате <u><i>тип String</i></u> вид 'YYYY-MM-DD'
  days: 281 Дней срока гарантии в <u><i>тип Number (integer)</i></u>
  gar_polz_zak: null Если не нужна гарантия в пользу заказчика иначе id заказчика из массива “gar_polz_zak” <u><i>тип Number (integer)</i></u>
  isAvans: Наличие аванса значения могут быть "Нет" | "Да" <u><i>тип String</i></u>
  isBS: Условие о бесспорном списании значения могут быть "Нет" | "Да" <u><i>тип String</i></u>
  isGarFormZak: Гарантия по форме заказчика значения могут быть "Нет" | "Да" <u><i>тип String</i></u>
  isPaper: Требуется оригинал гарантии на бумаге значения могут быть "Нет" | "Да" <u><i>тип String</i></u>
  purchase_number: Номер закупки если есть значения могут быть <u><i>тип String</i></u>
  lot: Номер лота значения могут быть <u><i>тип Number (integer)</i></u> | 1 если нет
  nmkc: значения могут быть <u><i>тип Number (integer)</i></u> | 0 если нет
  purchasesVal: Значения id из таблицы “purchase” <u><i>тип Number (integer)</i></u>
  quaranteesVal: Значения id из таблицы “quarantee” <u><i>тип Number (integer)</i></u>
  session:  Значения session из DataToCalc <u><i>тип String</i></u>
  summ: Значения <u><i>тип Number (integer)</i></u>
  trebUvelSumm: Значения увеличения в 1,5 раза от суммы <u><i>Boolean (true | false)</i></u>
  trebUvelSumm2: Значения увеличения в 2 раза от суммы <u><i>Boolean (true | false)</i></u>
  your_situation: Значения id из таблицы “your_situation” <u><i>тип Number (integer)</i></u>
}

`,
  getres: `{
  purchase: [
    {
    id: Number (integer)
    name: String
    }
  ],
  quarantee: [
    {
      id: Number (integer)
      name: String
      avans: Boolean ( 0 не нужен, 1 нужен аванс)
    }
  ],
  gar_polz_zak:[
    {
    id: Number (integer)
    name: String
    }
  ],
  your_situation:[
    {
    id: Number (integer)
    name: String
    }
  ],
  session: String
}
`
  }),
  methods: {
    GenApiKey(){
      this.$store.dispatch('GEN_API_KEY')
    }
  },
  computed: {
    api_key(){return this.$store.getters.getCalcCount.api_key},
    api(){return this.$store.getters.getCalcCount.api}
  },
};
</script>
<style lang="sass" scoped>
</style>
